const Utils = {
  ConvertStringToHTML(str) {
    let parser = new DOMParser()
    let doc = parser.parseFromString(str, 'text/html')
    return doc.body
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script")
    script.text = str
    document.head.appendChild(script).parentNode.removeChild(script)
  },
  async PromisesSequential(PromiseArr) {
    let res = [];
    for (let i=0; i < PromiseArr.length; i++) {
      res.push(await PromiseArr[i])
    }
    return res
  },
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);
    
    observer.observe(node, config);  
    return observer;
  }
};

const QuickPopupPersonalize = () => {
  return {
    name: '',
    cache: {},
    flags: {
      open: false
    },
    init() {
      let am = this;
      am.InitSelf();

      am.$watch('name', () => {
        am.cache.$atc_btn.disabled = am.name.length == 0;
      });
    },
    InitSelf() {
      let am = this;
      am.cache.$form = am.$el.closest('.shopify-product-form');
      am.cache.$id = am.cache.$form.querySelector('input[name=id]');
      am.cache.$atc_btn = am.cache.$form.querySelector('button');

      am.cache.$id.value = am.$el.dataset.variant_id;
    },
    e_OnAddToCart(e) {
      let am = this;
      // console.log(e.target.classList)
      if (e.target.classList.contains('group/quick-action-button')) {
        setTimeout(() => {
          am.name = ''
          am.flags.open = false
        }, 1000)
      }
    }
  };
}

const CollectionLoadMore = () => {
  return {
    collection: _collection,
    cache: {},
    flags: {
      loading: true
    },
    page: 1,
    init() {
      let am = this;
      am.InitSelf();

      am.$watch('flags.loading', () => {
        am.cache.$collection.dispatchEvent(new CustomEvent('collection:loading:status_change', {detail: {loading: am.flags.loading}}));
      });


      am.cache.$collection.addEventListener('collection:load:next_page', (e) => {
        am.page = e.detail.page;
        am.flags.loading = true;
        setTimeout(am.LoadNextPage.bind(am), 1000);
      });
    },
    InitSelf() {
      let am = this;
      am.cache.$collection = am.$el;
      am.cache.$products_grid = am.$el.querySelector('.js-grid');
    },
    async LoadNextPage() {
      let am = this;
      am.flags.loading = true;

      let section_id = am.$el.dataset.section_id;
      let view = am.$el.dataset.view || '';
      let url_separator = window.location.href.indexOf('?') == -1 ? '?' : '&';
      let px_url = `${ window.location.href }${ url_separator }page=${ am.page }&sections=${ section_id }&view=${ view }`;
      // console.log(px_url);

      let res = await fetch(px_url).then(res => res.json());
      let $res_section = Utils.ConvertStringToHTML(res[section_id]);
      let $products = $res_section.querySelectorAll('product-grid-item');
      $products.forEach(($product) => {
        am.$el.querySelector('.js-grid').insertAdjacentElement('beforeend', $product);
      });
      am.flags.loading = false;
    },
    LoadAllPages() {
      let am = this;
      let section_id = am.$el.dataset.section_id;
      let view = am.$el.dataset.view || '';
      let url_separator = window.location.href.indexOf('?') == -1 ? '?' : '&';

      (async () => {
        let urls = [];
        for (let i = 2; i <= am.paginate.pages; i++) {
          urls.push(`${ window.location.href }${ url_separator }page=${ i }&sections=${ section_id }&view=${ view }`)
        }
        // console.log(urls);
        let px_urls = urls.map(async(url) => {
          return await fetch(url).then(res => res.json())
        })

        let px_res = await Utils.PromisesSequential(px_urls)
        px_res.forEach((res) => {
          let $res_section = Utils.ConvertStringToHTML(res[section_id]);
          // console.log($res_section);

          let $products = $res_section.querySelectorAll('product-grid-item');
          $products.forEach(($product) => {
            am.cache.$products_grid.insertAdjacentElement('beforeend', $product);
            // $product.setAttribute('data-transition-active', 'true');
          });

          am.flags.loading = false;
        })
      })()
    }        
  }
}

const CollectionPaginate = () => {
  return {
    paginate: _paginate,
    cache: {},
    flags: {
      loading: true,
      isLastPage: false
    },
    page: 1,
    init() {
      let am = this;
      am.InitSelf();
      // am.LoadAllPages();

      am.$watch('flags.loading', () => {
        am.cache.$loading_gif.classList.toggle('is-loading', am.flags.loading);
      });

      am.cache.$collection.addEventListener('collection:loading:status_change', (e) => {
        am.flags.loading = e.detail.loading;
      });

      Utils.ObserveIntersection(am.cache.$loading_gif, {}, (entries) => {
        // console.log(entries)
        let isLastPage = am.page == am.paginate.pages;
        am.flags.isLastPage = isLastPage;
        if (!isLastPage && entries[0].isIntersecting) {
          am.flags.loading = true;
          am.page += 1;
          am.cache.$collection.dispatchEvent(new CustomEvent('collection:load:next_page', {detail: {page: am.page}}))
        }
      });
    },
    InitSelf() {
      let am = this;
      am.cache.$collection = am.$el.closest('.collection__products');
      am.cache.$loading_gif = am.$el;
      am.flags.isLastPage = am.paginate.pages == am.page;
      // console.log(am.cache)
    }
  }
}